import {
    GET_CODE,
    UPDATE_CODE,
    VERIFY_CODE,
    GENERATE_CODE,
    SEARCH_CODE,
    GET_CODE_STAT,
    GET_NAME_LIST
} from "./actions.type";
import {codeService} from "../service/codeService";
import {dashboardService} from "../service/dashboardService";

function initState() {
    return {
        nameList :[],
        list: [],
        stat: {}
    }
}

const state = initState();

const actions = {
    // eslint-disable-next-line no-empty-pattern
    async [GET_CODE]({commit}) {
        let data = await codeService.getCode();
        commit(GET_CODE, data);
    },

    async [SEARCH_CODE]({commit}, data) {
        let result = await codeService.search(data);
        if(result){
            commit(GET_CODE, result);
        }
    },

    async [GET_NAME_LIST]({commit}) {
        let result = await codeService.getNameList();
        if(result){
            commit(GET_NAME_LIST, result);
        }
    },

    // eslint-disable-next-line no-empty-pattern
    async [UPDATE_CODE]({}, data) {
        return await codeService.updateCode(data.name, data.value);
    },

    // eslint-disable-next-line no-empty-pattern
    async [VERIFY_CODE]({}, code) {
        return await codeService.verifyCode(code);
    },

    // eslint-disable-next-line no-empty-pattern
    async [GENERATE_CODE]({}, code) {
        return await codeService.generateCode(code);
    },

    async [GET_CODE_STAT]({commit}, data) {
        let result = await dashboardService.getCode(data);
        if (result) {
            commit(GET_CODE_STAT, result);
            return result;
        }
    },
};

const mutations = {
    [GET_CODE](state, data) {
        state.list = data;
    },
    [GET_CODE_STAT](state, data) {
        state.stat = data;
    },
    [GET_NAME_LIST](state, data) {
        state.nameList = data;
    }
};

const getters = {};

export default {
    state,
    actions,
    mutations,
    getters
};
